// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_NrR","right":"styles_right__3PJ0q"};